<ndt-register-view
  [name]="name"
  [totalCount]="totalCount"
  [callState]="callState"
  [hasNextPage]="hasNextPage"
  [pagingCallState]="pagingCallState"
  [searchText]="searchText"
  [showCreate]="false"
  (quickFilterChange)="onQuickFilterChange($event)"
  (loadMore)="onLoadMore()"
  [pluralNameOverride]="'System Logs'"
  >
  <ndt-register-quick-filter>
    <ndt-date-filter
      [fromDate]="startDate"
      [toDate]="endDate"
      (logQuickFilterChanged)="onDateQuickFilterChange($event)"
      class="date-filter"
    ></ndt-date-filter>
    <mat-form-field>
      <mat-label>Filter by Severity</mat-label>
      <input
        [lcsSingleSelect]="systemLogSeveritySelect"
        ndtSystemLogSeveritySelect
        autocomplete="off"
        type="text"
        [ngModel]="selectedSeverityType"
        (ngModelChange)="onSeverityTypeSelected($event)"
        id="severity-type"
        />
        <ndt-system-logs-severity-select
          #systemLogSeveritySelect
          isIncludeEmptyOption="true"
        ></ndt-system-logs-severity-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Filter by Type</mat-label>
        <input
          [lcsSingleSelect]="systemLogTypeSelect"
          ndtSystemLogTypeSelect
          autocomplete="off"
          type="text"
          [ngModel]="selectedSystemLogType"
          (ngModelChange)="onSystemLogTypeSelected($event)"
          id="log-type"
          />
          <ndt-system-logs-type-select #systemLogTypeSelect isIncludeEmptyOption="true"></ndt-system-logs-type-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Filter by Area</mat-label>
          <input
            [lcsSingleSelect]="systemLogsAreaSelect"
            ndtSystemLogAreaSelect
            autocomplete="off"
            type="text"
            [ngModel]="selectedSystemLogArea"
            (ngModelChange)="onSystemLogAreaSelected($event)"
            id="log-area"
            />
            <ndt-system-logs-area-select #systemLogsAreaSelect isIncludeEmptyOption="true"></ndt-system-logs-area-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Filter by Account</mat-label>
            <input
              [lcsSingleSelect]="ndtAccountSelect"
              ndtAccountSelect
              autocomplete="off"
              type="text"
              [value]="selectedAccount?.name"
              [ngModel]="selectedAccount"
              (ngModelChange)="onAccountSelected($event)"
              id="account-filter"
              />
              <ndt-account-select #ndtAccountSelect isIncludeEmptyOption="true"></ndt-account-select>
            </mat-form-field>
          </ndt-register-quick-filter>
          <lcs-responsive-table [columns]="columns">
            <table lcs-table [dataSource]="dataSource">
              <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
              <tr lcs-row *lcsResponsiveRowDef></tr>
              <ng-container lcsColumnDef="createUserDate" width="2.5">
                <th
                  lcs-header-cell
                  *lcsHeaderCellDef
                  id="createUserDate-column-header"
                  ndtSortColumn
                  (emitter)="onOrderingOptionsChange($event)"
                  [sortDirection]="getOrderingOption(orderingOptions, 'createUserDate')"
                  sortField="createUserDate"
                  >Date/Time<mat-icon class="mat-icon-sort">{{ getSort('createUserDate') }}</mat-icon></th
                  >
                  <td lcs-cell *lcsCellDef="let systemLog">
                    <a (click)="onOpenLogDialog(systemLog)">{{
                      systemLog.createUserDate | date : 'MM/dd/yyyy hh:mm:ss aa'
                    }}</a>
                  </td>
                </ng-container>
                <ng-container lcsColumnDef="message" width="6">
                  <th
                    lcs-header-cell
                    *lcsHeaderCellDef
                    id="message-column-header"
                    ndtSortColumn
                    (emitter)="onOrderingOptionsChange($event)"
                    [sortDirection]="getOrderingOption(orderingOptions, 'message')"
                    sortField="message"
                    >Message<mat-icon class="mat-icon-sort">{{ getSort('message') }}</mat-icon></th
                    >
                    <td lcs-cell *lcsCellDef="let systemLog">
                      <a (click)="onOpenLogDialog(systemLog)">{{ systemLog.message }}</a>
                    </td>
                  </ng-container>
                  <ng-container lcsColumnDef="severityId" width="1">
                    <th
                      lcs-header-cell
                      *lcsHeaderCellDef
                      id="severity-column-header"
                      ndtSortColumn
                      (emitter)="onOrderingOptionsChange($event)"
                      [sortDirection]="getOrderingOption(orderingOptions, 'severityName')"
                      sortField="severityName"
                      >Severity<mat-icon class="mat-icon-sort">{{ getSort('severityName') }}</mat-icon></th
                      >
                      <td lcs-cell *lcsCellDef="let systemLog">
                        <a (click)="onOpenLogDialog(systemLog)">{{ systemLog.severityId }}</a>
                      </td>
                    </ng-container>
                    <ng-container lcsColumnDef="typeId" width="2">
                      <th
                        lcs-header-cell
                        *lcsHeaderCellDef
                        id="type-column-header"
                        ndtSortColumn
                        (emitter)="onOrderingOptionsChange($event)"
                        [sortDirection]="getOrderingOption(orderingOptions, 'typeName')"
                        sortField="typeName"
                        >Type<mat-icon class="mat-icon-sort">{{ getSort('typeName') }}</mat-icon></th
                        >
                        <td lcs-cell *lcsCellDef="let systemLog">
                          <a (click)="onOpenLogDialog(systemLog)">{{ systemLog.typeId | addSpaces }}</a>
                        </td>
                      </ng-container>
                      <ng-container lcsColumnDef="areaId" width="1.5">
                        <th
                          lcs-header-cell
                          *lcsHeaderCellDef
                          id="area-column-header"
                          ndtSortColumn
                          (emitter)="onOrderingOptionsChange($event)"
                          [sortDirection]="getOrderingOption(orderingOptions, 'areaName')"
                          sortField="areaName"
                          >Area<mat-icon class="mat-icon-sort">{{ getSort('areaName') }}</mat-icon></th
                          >
                          <td lcs-cell *lcsCellDef="let systemLog">
                            <a (click)="onOpenLogDialog(systemLog)">{{ systemLog.areaId | addSpaces }}</a>
                          </td>
                        </ng-container>
                        <ng-container lcsColumnDef="accountName" width="2">
                          <th
                            lcs-header-cell
                            *lcsHeaderCellDef
                            id="account-name-column-header"
                            ndtSortColumn
                            (emitter)="onOrderingOptionsChange($event)"
                            [sortDirection]="getOrderingOption(orderingOptions, 'account.name')"
                            sortField="account.name"
                            >Account<mat-icon class="mat-icon-sort">{{ getSort('account.name') }}</mat-icon></th
                            >
                            <td lcs-cell *lcsCellDef="let systemLog">
                              <a (click)="onOpenLogDialog(systemLog)">{{ systemLog.account?.name }}</a>
                            </td>
                          </ng-container>
                          <ng-container lcsColumnDef="systemLogActionsMenu" width="1">
                            <th lcs-header-cell *lcsHeaderCellDef id="system-log-actions-menu-column-header"></th>
                            <td lcs-cell *lcsCellDef="let systemLog">
                              <button
                                type="button"
                                mat-icon-button
                                aria-label="System Log Actions"
                                matTooltip="More Actions"
                                id="system-log-actions-menu"
                                [matMenuTriggerFor]="systemLogMenu"
                                ><mat-icon> more_horiz </mat-icon>
                              </button>
                              <mat-menu #systemLogMenu="matMenu">
                                <button mat-menu-item type="button" id="call-details" (click)="onOpenLogDialog(systemLog)">
                                  Log Details
                                </button>
                                @if (systemLog.callDetail?.callDetailId) {
                                  <button
                                    mat-menu-item
                                    type="button"
                                    id="call-details"
                                    (click)="onOpenDialog(systemLog.callDetail)"
                                    >
                                    Call Details
                                  </button>
                                }
                              </mat-menu>
                            </td>
                          </ng-container>
                        </table>
                      </lcs-responsive-table>
                    </ndt-register-view>
